import { useState, useEffect } from 'react';

let toastId = 0;
const toasts = [];
const listeners = new Set();

const toast = (props) => {
  const id = ++toastId;
  const toast = { id, ...props };
  toasts.push(toast);
  listeners.forEach((listener) => listener([...toasts]));
  
  if (props.duration !== Infinity) {
    setTimeout(() => {
      const index = toasts.findIndex((t) => t.id === id);
      if (index > -1) {
        toasts.splice(index, 1);
        listeners.forEach((listener) => listener([...toasts]));
      }
    }, props.duration || 3000);
  }
  
  return {
    id,
    dismiss: () => {
      const index = toasts.findIndex((t) => t.id === id);
      if (index > -1) {
        toasts.splice(index, 1);
        listeners.forEach((listener) => listener([...toasts]));
      }
    },
  };
};

export function useToast() {
  const [toastList, setToastList] = useState([]);

  useEffect(() => {
    const listener = (newToasts) => setToastList(newToasts);
    listeners.add(listener);
    listener([...toasts]);
    return () => {
      listeners.delete(listener);
    };
  }, []);

  return {
    toast,
    toasts: toastList,
  };
}

